import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f61bf7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-wrapper" }
const _hoisted_2 = { class: "card controls-container" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-container__spacing" }, null, -1))
const _hoisted_5 = { class: "info-container__main" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "category-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_play_button = _resolveComponent("play-button")!
  const _component_highscore_display = _resolveComponent("highscore-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_play_button, { onClick: _ctx.routeToGame }, null, 8, ["onClick"]),
        _createVNode(_component_highscore_display, { "game-name": _ctx.component }, null, 8, ["game-name"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["card info-container flex-center", { collapsed: _ctx.isCollapsed }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.collapse && _ctx.collapse(...args)))
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.name), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.description), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category,
            class: _normalizeClass(["category", _ctx.getClassByCategory(category)])
          }, [
            _createElementVNode("strong", null, _toDisplayString(category), 1)
          ], 2))
        }), 128))
      ])
    ], 2)
  ]))
}